import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-widget-core',
  templateUrl: './widget-core.component.html',
  styleUrls: ['./widget-core.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class WidgetCoreComponent {
  @Input() isClear: boolean = false;
}
